import React, { ComponentType, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  InputAttributes, NumberFormatBase, NumberFormatBaseProps, usePatternFormat,
} from 'react-number-format';

import { Input } from '@ast/magma/components/input';

import {
  FormControl,
} from '@app/common/components/controls/FormControl';

export interface ZipCodeInputProps extends Omit<NumberFormatBaseProps, 'removeFormatting' | 'getCaretBoundary'> {
  readonly name: string;
  readonly value?: string;
  readonly validationRules?: any;
  readonly getErrorMessage?: (error: any) => string;
  readonly containerClassName?: string;
  readonly fieldClassName?: string;
  readonly field?: any;
  readonly error?: string
  readonly label?: string;
  readonly errorMessage?: string;
}

export const ZipCodeInput: React.FC<ZipCodeInputProps> = ({
  id,
  name,
  defaultValue = '',
  validationRules,
  getErrorMessage,
  containerClassName,
  fieldClassName,
  format,
  ...props
}) => {
  const {
    setValue,
  } = useFormContext();

  useEffect(() => {
    setValue(name, defaultValue);
  }, [defaultValue]);

  const { removeFormatting, getCaretBoundary } = usePatternFormat({ format: '' });

  return (
    <FormControl
      name={name}
      validations={validationRules}
      getErrorMessage={getErrorMessage}
      className={containerClassName}
    >
      <NumberFormatBase
        getCaretBoundary={getCaretBoundary}
        removeFormatting={removeFormatting}
        format={format}
        className={fieldClassName}
        customInput={Input as ComponentType<InputAttributes> | undefined}
        aria-invalid={!!getErrorMessage}
        defaultValue={defaultValue}
        {...props}
      />
    </FormControl>
  );
};
